<div class="tracker-container">
  @for (stage of stages; track stage; let i = $index; let isFirst = $first) {
    @if (!isFirst) {
      <div class="tracker-in-between" [ngClass]="getClassForStatus(stage.status)"></div>
    }
    <div class="tracker-stage">
      <div class="tracker-stage-icon" [ngClass]="getClassForStatus(stage.status)">
        @if (stage.status === 'in_progress') {
          <div class="tracker-in-progress-icon">
            <span class="tracker-ellipsis-animation">.</span>
            <span class="tracker-ellipsis-animation">.</span>
            <span class="tracker-ellipsis-animation">.</span>
          </div>
        }
        @if (stage.status === 'completed') {
          <mat-icon>done</mat-icon>
        }
        @if (stage.status === 'failed') {
          <mat-icon>close</mat-icon>
        }
      </div>
      <div class="description-stage">
        <span>{{ stage.name }}</span>
      </div>
    </div>
  }
</div>
